import { useSelector } from 'react-redux';
import { PACK_CONFIG } from '../constants/packConfig';

/**
 * Retourne les permissions et limites du pack actif de l'agence connectée.
 * Pour le SuperAdmin (pas de pack), toutes les fonctionnalités sont accessibles.
 */
export const usePackPermissions = () => {
  const user = useSelector(s => s.auth.user);
  const pack = user?.pack;

  // SuperAdmin ou pas de pack → accès complet
  if (!pack || !PACK_CONFIG[pack]) {
    return {
      pack: null,
      packLabel: null,
      canAccess: () => true,
      vehicleLimit: -1,
      userLimit: -1,
      isUnlimited: true,
    };
  }

  const config = PACK_CONFIG[pack];

  return {
    pack,
    packLabel: config.label,
    canAccess: (feature) => config.features[feature] ?? true,
    vehicleLimit: config.vehicleLimit,
    userLimit: config.userLimit,
    isUnlimited: config.vehicleLimit === -1,
  };
};

export default usePackPermissions;
